import React from 'react'
import { home_grid, off_ongrid } from '../../Images'
import css from './HomePage.module.scss'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { battery_blank, battery_charged, battery_charging } from '../../Images/Icons'

const GridEnergyOffGrid = (props) => {
    const [showBottomSheet, hideBottomSheet] = useOutletContext();

    const onBattery = () => {
        showBottomSheet('',
            <div style={{ textAlign: 'center', margin: '0 20px', marginTop: -40 }}>
                <div style={{ height: 292, height: 150, }}>
                    <img src={battery_blank} alt="" style={{ width: 292, height: 180 }} />
                </div>
                <div style={{ height: 74, display: 'flex', justifyContent: 'space-between', background: 'white', marginTop: 40, borderRadius: 8 }}>
                    <div style={{ flex: 1, textAlign: 'center' }}>
                        <div style={{ fontSize: 24, fontWeight: 500, color: '#292929', marginTop: 10 }}>7.61 <span style={{ fontSize: 14, fontWeight: 500, color: '#BFBFBF' }}>kWh</span></div>
                        <div style={{ fontSize: 12, fontWeight: 400, color: '#6a6a6a' }}>Energy charged today</div>
                    </div>
                    <div style={{ flex: 1, textAlign: 'center' }}>
                        <div style={{ fontSize: 24, fontWeight: 500, color: '#292929', marginTop: 10 }}>6.42 <span style={{ fontSize: 14, fontWeight: 500, color: '#BFBFBF' }}>kWh</span></div>
                        <div style={{ fontSize: 12, fontWeight: 400, color: '#6a6a6a' }}>Energy discharged today</div>
                    </div>
                </div>
                <div style={{ height: 74, display: 'flex', justifyContent: 'space-between', marginTop: 10, marginBottom: 30, borderRadius: 8 }}>
                    <div style={{ flex: 1, textAlign: 'center', background: 'white', marginRight: 4, borderRadius: 6 }}>
                        <div style={{ fontSize: 12, fontWeight: 400, color: '#6a6a6a', marginTop: 10 }}>Remaining Capacity</div>
                        <div style={{
                            display: 'flex', justifyContent: 'center', alignItems: 'center',
                            height: 32, fontSize: 16, fontWeight: 700, color: '#292929', marginTop: 4
                        }}>41.0 %
                            <div style={{ marginLeft: 4 }}><img src={battery_charged} style={{ width: 32, height: 32 }} /></div>
                        </div>
                    </div>
                    <div style={{ flex: 1, textAlign: 'center', background: 'white', marginLeft: 4, borderRadius: 8 }}>
                        <div style={{ fontSize: 12, fontWeight: 400, color: '#6a6a6a', marginTop: 10 }}>Power (Charging)</div>
                        <div style={{
                            display: 'flex', justifyContent: 'center', alignItems: 'center',
                            height: 32, fontSize: 16, fontWeight: 700, color: '#292929', marginTop: 4
                        }}>2.051 kW</div>
                    </div>
                </div>
            </div>);
    }

    return (
        <div className={css.grid_offgrid}>
            <div className={css.image} style={{ position: 'relative' }}>
                {/* <img src={off_ongrid} /> */}
                <img src="/monitoring/assets/Off-Grid.gif" />
            </div>
            <div className={css.persen}>
                {props.data.return.battery.level}%<img src={battery_charging}/>
            </div> 
            <div className={css.home_value1}>
                PV
                <div>
                    <label>{props.data.return.pv.active_power} </label>
                    <span> kW</span>
                </div>
            </div>
            <div className={css.home_value2}>
                <div className={css.battery_button} onClick={onBattery}></div>
                <div>Battery<i className='fi-rr-angle-small-right'></i></div>
                <div>
                    <label>{props.data.return.battery.power} </label>
                    <span> kW</span>
                </div>
            </div>
            <div className={css.home_value4}>
                Consumption
                <div>
                    <label>{props.data.return.consumption.total} </label>
                    <span> kW</span>
                </div>
            </div>
        </div>
    )
}

export default GridEnergyOffGrid